<div class="btn-group w-100">
  <button
    class="btn btn-outline-secondary btn-sm dropdown-toggle text-left"
    data-toggle="dropdown"
    type="button"
  >
    <div *ngIf="activeDevice; else default">
      {{activeDevice.region}} ({{activeDevice.city}})
    </div>
    <ng-template #default>Select Location</ng-template>
  </button>
  <ul class="dropdown-menu w-100">
    <li><a (click)="onClickLocation($event)"
           id="{{device.city}}"
           *ngFor="let device of devices"
           class="dropdown-item"
           href="#">
      {{device.region}} ({{device.city}})
    </a></li>
  </ul>
</div>
